import React from 'react';

interface props {
    name: string;
    value: string;
    onClick: () => void;
}

export const DetailRow = ({ name, value, onClick }: props) => {
    return (
        <section style={{ minHeight: 40, width: '100%' }} className="space-between-flex">
            <div className="center-inside">
                <div style={{ width: 100, marginRight: 8 }} className="assessment-label ">
                    {name}
                </div>
                <div style={{ maxWidth: 203, paddingRight: 8 }} className="assessment-content ">
                    {value}
                </div>
            </div>
            <div
                style={{ width: 24 }}
                className="assessment-link button-style"
                onClick={() => onClick()}
            >
                修正
            </div>
        </section>
    );
};
